import { getCssVariable, pxToNumber } from './utils/css';

const subMenu = document.querySelector('.sub-menu');
const expandMenuButton = subMenu?.querySelector('.expand-menu-button');

/**
 * Initializes the submenu by adding scroll gradient and scrolling to the selected item.
 */
export default function initSubMenu() {
  if(!subMenu || !expandMenuButton) {
    return;
  }

  initExpandMenuButton();
  updateSubMenuBasedOnScreenSize();
}

/**
 * Initializes the expand menu button for toggling the submenu
 */
function initExpandMenuButton() {
  expandMenuButton.addEventListener('click', () => {
    const ariaExpanded = expandMenuButton.getAttribute('aria-expanded');
    if(ariaExpanded === 'true') {
      closeMenu();
    } else {
      openMenu();
    }
  });
}

/**
 * Opens the submenu
 */
function openMenu() {
  expandMenuButton.setAttribute('aria-expanded', true);
}

/**
 * Closes the submenu
 */
function closeMenu() {
  expandMenuButton.setAttribute('aria-expanded', false);
}

/**
 * Updates the submenu based on screen size
 */
function updateSubMenuBasedOnScreenSize() {
  const desktopBreakpoint = pxToNumber(getCssVariable('--screen-min-desktop'));
  const ariaExpanded = expandMenuButton.getAttribute('aria-expanded');

  if(window.innerWidth >= desktopBreakpoint) {
    expandMenuButton.removeAttribute('aria-expanded');
  } else if(ariaExpanded !== 'true') {
    expandMenuButton.setAttribute('aria-expanded', 'false');
  }

  if(!window.subMenuResizeListenerAdded) {
    window.addEventListener('resize', updateSubMenuBasedOnScreenSize);
    window.subMenuResizeListenerAdded = true;
  }
}
